export enum EnumLinedTextAreaType {
    Text = 1
}